module.exports = __webpack_public_path__ + "img/calendar2-plus-fill.b2e997f7.svg";